var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 163,
    viewBox: "0 0 145 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3418 2.02187C70.0911 -0.142839 74.7106 -0.142838 78.4599 2.02187L138.059 36.4316C141.809 38.5963 144.118 42.5968 144.118 46.9262V115.746C144.118 120.075 141.809 124.076 138.059 126.24L78.4599 160.65C74.7106 162.815 70.0911 162.815 66.3418 160.65L6.74242 126.24C2.99304 124.076 0.683329 120.075 0.683329 115.746V46.9262C0.683329 42.5968 2.99304 38.5963 6.74242 36.4316L66.3418 2.02187Z",
    stroke: "url(#paint0_linear_5525_2963)",
    strokeWidth: 0.781818
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5525_2963",
    x1: 72.4008,
    y1: -1.92773,
    x2: 72.4008,
    y2: 164.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.e6892f90e68597db93993ba66cac99f1.svg";
export { ForwardRef as ReactComponent };